/**
 * Club Loom Loom — Join button handler.
 * Adds the membership (with its selling plan, if any) to the cart via
 * /cart/add.js so it plays correctly with this theme's existing
 * membership-auto-add / membership-toggle cart logic, then sends the
 * shopper to their cart. Falls back to the button's normal href on error.
 */
(function () {
  'use strict';

  function setLoading(btn, isLoading) {
    if (isLoading) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = 'Adding…';
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.textContent = btn.dataset.originalText || btn.textContent;
      btn.removeAttribute('aria-busy');
    }
  }

  function handleClick(event) {
    var btn = event.currentTarget;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.dataset.clubJoinLoading === 'true') return;

    event.preventDefault();
    btn.dataset.clubJoinLoading = 'true';
    setLoading(btn, true);

    var item = { id: parseInt(variantId, 10), quantity: 1 };
    var sellingPlanId = btn.dataset.sellingPlanId;
    if (sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId, 10);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] }),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (err) {
            throw new Error((err && err.description) || 'Could not add membership to cart');
          });
        }
        return response.json();
      })
      .then(function () {
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        window.location.href = cartUrl;
      })
      .catch(function (err) {
        console.error('Club Loom Loom join error:', err);
        btn.dataset.clubJoinLoading = 'false';
        setLoading(btn, false);
        window.location.href = btn.href;
      });
  }

  function init() {
    document.querySelectorAll('[data-club-join-btn]').forEach(function (btn) {
      if (btn.dataset.clubJoinBound === 'true') return;
      btn.dataset.clubJoinBound = 'true';
      btn.addEventListener('click', handleClick);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
